<template>
    <div >
        <el-dialog
            title="Order History Detail"
            :visible.sync="dialogVisible"
            width="50%"
            :close-on-click-escape="false"
            :close-on-click-modal="false"
             @closed="onHidden"
            :before-close="onHidden"
            custom-class="loadingDiv"
            center>
            <div style="font-size:16px;">
                <div v-if="orderHistoryForm.action === 'Create shipment' || orderHistoryForm.action === 'Update shipment'" >
                    Action : {{orderHistoryForm.action}}<br>
                    message : {{orderHistoryForm.payload.message}}<br>
                    editor : {{orderHistoryForm.editor}}<br>
                    Name editor : {{orderHistoryForm.editorFirstName}}  {{orderHistoryForm.editorLastName}}<br>
                    employeeId : {{orderHistoryForm.employeeId}}<br>
                    success: {{orderHistoryForm.payload.success}}<br>
                    tracking Number: {{orderHistoryForm.payload.trackingNumber}}<br>
                    timestamp : {{this.$dayjs(orderHistoryForm.timestamp).format('YYYY-MM-DD HH:mm:ss')}}<br>
                    type : {{orderHistoryForm.type}} <br>
                    <!-- {{orderHistoryForm}} -->
                </div>
                <div v-if="orderHistoryForm.action === 'Create order'">
                    Action : {{orderHistoryForm.action}}<br>
                    editor : {{orderHistoryForm.editor}}<br>
                    Name editor : {{orderHistoryForm.editorFirstName}}  {{orderHistoryForm.editorLastName}}<br>
                    additionalDiscount : {{orderHistoryForm.payload.additionalDiscount}}<br>
                    deliveryCost : {{orderHistoryForm.payload.deliveryCost}}<br>
                    courierId : {{getCourier(orderHistoryForm.payload.courierId)}}<br>
                    address : {{orderHistoryForm.payload.customer.address}} {{orderHistoryForm.payload.customer.subDistrict}}
                    {{orderHistoryForm.payload.customer.district}} {{orderHistoryForm.payload.customer.province}} {{orderHistoryForm.payload.customer.zipcode}}
                    <br>
                    tag : {{orderHistoryForm.payload.customer.tag}}<br>
                    phoneNumber : {{orderHistoryForm.payload.customer.phoneNumber}}<br>
                    phoneNumberSec : {{orderHistoryForm.payload.customer.phoneNumberSec}}<br>
                    paymentType : {{getPaymentTypeEn(orderHistoryForm.payload.paymentType)}}<br>
                    purchaseChannelList : {{getPurchaseChannel(orderHistoryForm.payload.purchaseChannel)}}<br>
                    shopId : {{orderHistoryForm.payload.shopId}}<br>
                    paymentAmount : {{orderHistoryForm.payload.paymentAmount}}<br>
                    tracking Number: {{orderHistoryForm.payload.trackingNumber}}<br>
                    note : {{orderHistoryForm.payload.note}}<br>
                     <el-table
                        :data="orderHistoryForm.payload.products"
                        style="width: 800%">
                            <el-table-column
                            prop="sku"
                            label="Product sku"
                            width="140"
                            fixed
                            >
                            </el-table-column>
                            <el-table-column
                            prop="name"
                            label="name"
                            width="240">
                            </el-table-column>
                            <el-table-column
                            prop="quantity"
                            label="Quantity"
                            width="100"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="price"
                            label="Price"
                            width="100"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="discount"
                            label="Discount"
                            width="100"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="weight"
                            label="Weight"
                            width="100"
                            >
                            </el-table-column>
                        </el-table>
                    <!-- {{orderHistoryForm}} -->
                </div>
                <div v-if="orderHistoryForm.action === 'Create order (FB Live)'">
                    Action : {{orderHistoryForm.action}}<br>
                    editor : {{orderHistoryForm.editor}}<br>
                    Name editor : {{orderHistoryForm.editorFirstName}}  {{orderHistoryForm.editorLastName}}<br>
                    additionalDiscount : {{orderHistoryForm.payload.additionalDiscount}}<br>
                    deliveryCost : {{orderHistoryForm.payload.deliveryCost}}<br>
                    courierId : {{getCourier(orderHistoryForm.payload.courierId)}}<br>
                    address : {{orderHistoryForm.payload.shippingAddress}} {{orderHistoryForm.payload.shippingSubDistrict}}
                    {{orderHistoryForm.payload.shippingDistrict}} {{orderHistoryForm.payload.shippingProvince}} {{orderHistoryForm.payload.shippingZipcode}}
                    <br>
                    tag : {{orderHistoryForm.payload.shippingTag}}<br>
                    phoneNumber : {{orderHistoryForm.payload.shippingPhoneNumber}}<br>
                    paymentType : {{getPaymentTypeEn(orderHistoryForm.payload.paymentType)}}<br>
                    shopId : {{orderHistoryForm.payload.shopId}}<br>
                    paymentAmount : {{orderHistoryForm.payload.paymentAmount}}<br>
                    tracking Number: {{orderHistoryForm.payload.trackingNumber}}<br>
                    note : {{orderHistoryForm.payload.note}}<br>
                    facebook_live_order_ids : {{orderHistoryForm.payload.facebookLiveOrderIds.join(',')}}<br>
                     <el-table
                        :data="orderHistoryForm.payload.products"
                        style="width: 800%">
                            <el-table-column
                            prop="sku"
                            label="Product sku"
                            width="140"
                            fixed
                            >
                            </el-table-column>
                            <el-table-column
                            prop="name"
                            label="name"
                            width="240">
                            </el-table-column>
                            <el-table-column
                            prop="quantity"
                            label="Quantity"
                            width="100"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="price"
                            label="Price"
                            width="100"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="discount"
                            label="Discount"
                            width="100"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="weight"
                            label="Weight"
                            width="100"
                            >
                            </el-table-column>
                        </el-table>
                </div>
                <div v-if="orderHistoryForm.action === 'Edit order'">
                    Action : {{orderHistoryForm.action}}<br>
                    editor : {{orderHistoryForm.editor}}<br>
                    Name editor : {{orderHistoryForm.editorFirstName}}  {{orderHistoryForm.editorLastName}}<br>
                    additionalDiscount : {{orderHistoryForm.payload.additionalDiscount}}<br>
                    deliveryCost : {{orderHistoryForm.payload.deliveryCost}}<br>
                    courierId : {{getCourier(orderHistoryForm.payload.courierId)}}<br>
                    address : {{orderHistoryForm.payload.customer.address}} {{orderHistoryForm.payload.customer.subDistrict}}
                    {{orderHistoryForm.payload.customer.district}} {{orderHistoryForm.payload.customer.province}} {{orderHistoryForm.payload.customer.zipcode}}
                    <br>
                    tag : {{orderHistoryForm.payload.customer.tag}}<br>
                    phoneNumber : {{orderHistoryForm.payload.customer.phoneNumber}}<br>
                    phoneNumberSec : {{orderHistoryForm.payload.customer.phoneNumberSec}}<br>
                    paymentType : {{getPaymentTypeEn(orderHistoryForm.payload.paymentType)}}<br>
                    purchaseChannelList : {{getPurchaseChannel(orderHistoryForm.payload.purchaseChannel)}}<br>
                    shopId : {{orderHistoryForm.payload.shopId}}<br>
                    paymentAmount : {{orderHistoryForm.payload.paymentAmount}}<br>
                    tracking Number: {{orderHistoryForm.payload.trackingNumber}}<br>
                    note : {{orderHistoryForm.payload.note}}<br>
                     <el-table
                        :data="orderHistoryForm.payload.products"
                        style="width: 100%">
                            <el-table-column
                            prop="sku"
                            label="Product sku"
                            width="140"
                            fixed
                            >
                            </el-table-column>
                            <el-table-column
                            prop="name"
                            label="name"
                            width="240">
                            </el-table-column>
                            <el-table-column
                            prop="quantity"
                            label="Quantity"
                            width="100"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="price"
                            label="Price"
                            width="100"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="discount"
                            label="Discount"
                            width="100"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="weight"
                            label="Weight"
                            width="100"
                            >
                            </el-table-column>
                        </el-table>
                    <!-- {{orderHistoryForm}} -->
                </div>
                <div v-if="orderHistoryForm.action === 'Delete order' || orderHistoryForm.action === 'Delete order (OMS)'">
                    Action : {{orderHistoryForm.action}}<br>
                    editor : {{orderHistoryForm.editor}}<br>
                    Name editor : {{orderHistoryForm.editorFirstName}}  {{orderHistoryForm.editorLastName}}<br>
                    employeeId : {{orderHistoryForm.employeeId}}<br>
                    timestamp : {{this.$dayjs(orderHistoryForm.timestamp).format('YYYY-MM-DD HH:mm:ss')}}<br>
                    orderNumber: {{orderHistoryForm.orderNumber}}<br>
                    type : {{orderHistoryForm.type}} <br>
                    <!-- {{orderHistoryForm}} -->
                </div>
                <div v-if="orderHistoryForm.action === 'Undelete order'">
                    Action : {{orderHistoryForm.action}}<br>
                    editor : {{orderHistoryForm.editor}}<br>
                    Name editor : {{orderHistoryForm.editorFirstName}}  {{orderHistoryForm.editorLastName}}<br>
                    employeeId : {{orderHistoryForm.employeeId}}<br>
                    timestamp : {{this.$dayjs(orderHistoryForm.timestamp).format('YYYY-MM-DD HH:mm:ss')}}<br>
                    orderNumber: {{orderHistoryForm.orderNumber}}<br>
                    type : {{orderHistoryForm.type}} <br>
                    <!-- {{orderHistoryForm}} -->
                </div>
                <div v-if="orderHistoryForm.action === 'Edit order (OMS)' || orderHistoryForm.action === 'Edit order (Mobile - OMS)' ">
                    Action : {{orderHistoryForm.action}}<br>
                    editor : {{orderHistoryForm.editor}}<br>
                    Name editor : {{orderHistoryForm.editorFirstName}}  {{orderHistoryForm.editorLastName}}<br>
                    orderNumber : {{orderHistoryForm.payload.orderNumber}}<br>
                    shippingAddress : {{orderHistoryForm.payload.shippingAddress}}<br>
                    shippingDistrict : {{orderHistoryForm.payload.shippingDistrict}}<br>
                    shippingSubDistrict : {{orderHistoryForm.payload.shippingSubDistrict}}<br>
                    shippingProvince : {{orderHistoryForm.payload.shippingProvince}}<br>
                    shippingZipcode : {{orderHistoryForm.payload.shippingZipcode}}<br>
                    note: {{orderHistoryForm.payload.note}}<br>
                    isReprint: {{orderHistoryForm.payload.isReprint}}<br>
                    trackingNumber: {{orderHistoryForm.payload.trackingNumber}}<br>
                    courierId: {{getCourier(orderHistoryForm.payload.courierId)}}<br>
                    userId : {{orderHistoryForm.payload.userId}}<br>
                    timestamp : {{this.$dayjs(orderHistoryForm.timestamp).format('YYYY-MM-DD HH:mm:ss')}}<br>

                    type : {{orderHistoryForm.type}} <br>
                </div>
                <div v-if="orderHistoryForm.action === 'Tag name'">
                    Action : {{orderHistoryForm.action}}<br>
                    editor : {{orderHistoryForm.editor}}<br>
                    Name editor : {{orderHistoryForm.editorFirstName}}  {{orderHistoryForm.editorLastName}}<br>
                    orderNumber : {{orderHistoryForm.payload.orderNumber}}<br>
                    csNote : {{orderHistoryForm.payload.csNote}}<br>
                    tag : {{orderHistoryForm.payload.tag}}<br>
                    userId : {{orderHistoryForm.payload.userId}}<br>
                    employeeId : {{orderHistoryForm.employeeId}}<br>
                    timestamp : {{this.$dayjs(orderHistoryForm.timestamp).format('YYYY-MM-DD HH:mm:ss')}}<br>
                    type : {{orderHistoryForm.type}} <br>
                </div>
                <div v-if="orderHistoryForm.action === 'Status Change'" >
                    Action : {{orderHistoryForm.action}}<br>
                    status : {{getOrderStatus(orderHistoryForm.payload.oldStatus)}} >  {{getOrderStatus(orderHistoryForm.payload.status)}}<br>
                    note : {{orderHistoryForm.payload.note ? orderHistoryForm.payload.note : ''}}<br>
                    editor : {{orderHistoryForm.editor}}<br>
                    Name editor : {{orderHistoryForm.editorFirstName}}  {{orderHistoryForm.editorLastName}}<br>
                    timestamp : {{this.$dayjs(orderHistoryForm.timestamp).format('YYYY-MM-DD HH:mm:ss')}}<br>
                    type : {{orderHistoryForm.type}} <br>
                    <!-- {{orderHistoryForm}} -->
                </div>
</div>
             <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">ยกเลิก</el-button>
            </span>

            </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'OrderHistoryDetail',
    props: {
        dialogShow: {
            type: Boolean,
            default: false
        },
        orderHistory: {
            type: Object,
            default: null
        }

    },
    data () {
        return {
            dialogVisible: false,
            orderHistoryForm: {}
        }
    },
    watch: {
        dialogShow (val) {
            if (val) {
                // init data agian
                this.dialogVisible = true
            }
        },
        orderHistory (val) {
            if (val) {
                this.orderHistoryForm = val
            }
        }

    },
    methods: {
        onHidden (done) {
            this.$emit('closeModal')
            if (done !== undefined) {
                done()
            }
        }

    }
}
</script>

<style lang="scss" scoped>
.break-word{
    overflow-wrap: break-word;
}
</style>
